import { Reward } from '@klubovna/api-client';
import { PaginationMetadata } from '@shared';

export interface RewardsState {
  rewards: Reward[];
  loading: boolean;
  error: string | null;
  pagination: PaginationMetadata;
}

export const initialRewardsState: RewardsState = {
  rewards: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};
